import React, { useEffect } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "./App.css";
import Header from "./Header";
import { auth } from "./firebase";
import { useStateValue } from "./StateProvider";
import Login from "./Login";
import Register from "./Register.js";
import NotVerified from "./NotVerified";
import SetUp1 from "./SetUp1.js";
import SetUp from "./SetUp.js";
import Wagers from "./Wagers.js";
import HolePage from "./HolePage";
import Distances from "./Distances";
import Yardages from "./Yardages";
import Summary from "./Summary";
import Footer from "./Footer";
import Geolocator from "./Geolocator";
import PinLocation from "./PinLocation";
import Menu from "./Menu";
import Range from "./Range";
import PinLocations from "./PinLocations";
import DistancesLive from "./DistancesLive";
import EliminationDraw from "./EliminationDraw";

function App() {
  const [{ user }, dispatch] = useStateValue();

  //code that runs based on a condition
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((authUser) => {
      if (authUser) {
        //user logged in
        dispatch({
          type: "SET_USER",
          user: authUser,
        });
      } else {
        //the user is logged out
        dispatch({
          type: "SET_USER",
          user: null,
        });
      }
    });

    return () => {
      //cleanup operations
      unsubscribe();
    };
  }, [user]);

  // console.log("Auth USER IS >>>>", user?.emailVerified)

  return (
    <Router>
      <div className="App">
        <Switch>
          <Route path="/register">
            <Register />
          </Route>

          {user && !user.emailVerified && (
            <Route path="/setup">
              <NotVerified />
            </Route>
          )}

          {user && user?.emailVerified && (
            <Route path="/setup">
              <Header />
              <SetUp1 />
              <Geolocator />
              <Footer />
            </Route>
          )}
          {user && user?.emailVerified && (
            <Route path="/setup1">
              <Header />
              <SetUp />
              <Geolocator />
              <Footer />
            </Route>
          )}

          {user && user?.emailVerified && (
            <Route path="/wagers">
              <Header />
              <Wagers />
              <Footer />
            </Route>
          )}

          {user && user?.emailVerified && (
            <Route path="/scoring">
              <Header />
              <HolePage />
              {/* <Distances/> */}
              {/* <Footer /> */}
            </Route>
          )}
          {user && user?.emailVerified && (
            <Route path="/yardages">
              <Header />
              <Distances />
              <DistancesLive />
              <PinLocations />
              <Yardages />
              {/* <Footer /> */}
            </Route>
          )}

          {user && user?.emailVerified && (
            <Route path="/yardageslive">
              <Header />
              <DistancesLive />
              <Yardages />
            </Route>
          )}

          {user && user.email === "docdatainc@gmail.com" && (
            <Route path="/locations">
              <Header />
              <PinLocation />
              <DistancesLive />
              <PinLocations />
            </Route>
          )}

          {user && user?.emailVerified && (
            <Route path="/summary">
              <Header />
              <Summary />
            </Route>
          )}

          {user && user?.emailVerified && (
            <Route path="/draw">
              <Header />
              <EliminationDraw />
            </Route>
          )}

          {user && user?.emailVerified && (
            <Route path="/range">
              <Header />
              <Range />
              <Footer />
            </Route>
          )}

          {user && user?.emailVerified && (
            <Route path="/menu">
              <Header />
              <Menu />
              <Footer />
            </Route>
          )}
          <Route path="/">
            <Login />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
